import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { Col } from 'reactstrap';
import Select, { MultiValue } from 'react-select';

export type SelectItemsProps = {
    label: string,
    value: string
}

export type SelectComponentProps = {
    label: string;
    items?: SelectItemsProps[];
    //onChange: (text: any) => void;
    //selectedItemValue: string | null;
    setSelectedString: React.Dispatch<React.SetStateAction<string>> | any,
    selectString: string | any;
    xs?: number;
    sm?: number;
    md?: number;
    lg: number;
    xl?: number;
    style?: React.CSSProperties | undefined;
    isDisabled?: boolean;
    itemsLoader?: () => Promise<SelectItemsProps[]>;
}

export default function MultiSelectComponent(props: SelectComponentProps) {
    const intl = useIntl();
    // const onInputChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    //     props.onChange(e.target.value);
    // }

    const [items, setItems] = useState<SelectItemsProps[]>([]);
    useEffect(() => {
        if (props.itemsLoader) {
            props.itemsLoader().then((items) => setItems(items));
        }
    }, [props.itemsLoader]);

    useEffect(() => {
        props.selectString != null && stringToSelected()
    }, [props.selectString, props.items])

    const [selectedOptions, setSelectedOptions] = useState<any>();

    const handleChange = (selected: MultiValue<SelectItemsProps>) => {

        //Transformar select value em string e.g. 1,2,5 para usar no filtro
        let selectedString = "";
        selectedString = selected.map(
            (x) => x.value
        ).join(",")
        setSelectedOptions(selected);

        props.setSelectedString(selectedString)
    };

    const stringToSelected = () => {
        //Transformar a string dos filtros para o array de objectos das opções
        if (props.items) {
            const values = props.selectString.split(",");
            let selectedArray = props.items.filter((item) => values.includes(item.value));
            setSelectedOptions(selectedArray);
        }
    }

    return (
        <Col xl={props.xl} lg={props.lg} md={props.md} sm={props.sm} xs={props.xs} className='inputContainer'>
            <span className="label" >{props.label}:</span>
            <div>
                <Select
                    isMulti
                    name="multiSelect"
                    placeholder={intl.formatMessage({ id: "SelectComponent.DefaultValue" })}
                    options={props.items ?? items}
                    value={selectedOptions}
                    onChange={handleChange}
                    isDisabled={props.isDisabled}
                    className="basic-multi-select"
                    classNamePrefix="select"

                    theme={(theme) => ({
                        ...theme,
                        borderRadius: 10,
                        colors: {
                            ...theme.colors,
                            primary: "black",
                        }
                    })}
                />
            </div>
        </Col>
    )
}